export default "__VITE_ASSET__DJe0t9sL__"